import { render, staticRenderFns } from "./DesignEmailModal.vue?vue&type=template&id=566a7f74&scoped=true&"
import script from "./DesignEmailModal.vue?vue&type=script&lang=js&"
export * from "./DesignEmailModal.vue?vue&type=script&lang=js&"
import style0 from "./DesignEmailModal.vue?vue&type=style&index=0&id=566a7f74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566a7f74",
  null
  
)

export default component.exports